export {default} from './ArrangedIcons';
